import axios from "axios";
import dayjs from "dayjs";
import { server } from "../api";

// The backend wants naive server-local "YYYY-MM-DD HH:mm:ss" strings for
// range inputs (see the History API contract); every hook in
// HistoryWorkspaceModal works in epoch ms, so the ms->string conversion is
// centralized here rather than duplicated at each call site.
const fmt = (ms) => dayjs(ms).format("YYYY-MM-DD HH:mm:ss");

const IndoorPositioningHistory = {
  // `include` is the contract's comma-separated opt-in list (currently just
  // "equipment"). Omitted by default so any other caller of GetFrames keeps
  // today's personnel-only response untouched.
  GetFrames: async (machineID, startMs, endMs, intervalS, signal, include) => {
    try {
      const params = {
        start: fmt(startMs),
        end: fmt(endMs),
        interval: intervalS,
      };
      if (include) params.include = include;
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/history/frames`,
        { params, signal },
      );
      return response.data;
    } catch (error) {
      if (axios.isCancel(error) || error?.name === "CanceledError") throw error;
      return (
        error.response?.data || {
          code: 500,
          message: "獲取歷史軌跡資料失敗",
        }
      );
    }
  },

  GetAlerts: async (machineID, startMs, endMs, afterId, limit, signal) => {
    try {
      const params = { start: fmt(startMs), end: fmt(endMs), limit };
      if (afterId != null) params.after_id = afterId;
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/history/alerts`,
        { params, signal },
      );
      return response.data;
    } catch (error) {
      if (axios.isCancel(error) || error?.name === "CanceledError") throw error;
      return (
        error.response?.data || {
          code: 500,
          message: "獲取歷史警報資料失敗",
        }
      );
    }
  },

  GetAvailability: async (machineID, startMs, endMs, signal) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/history/availability`,
        { params: { start: fmt(startMs), end: fmt(endMs) }, signal },
      );
      return response.data;
    } catch (error) {
      if (axios.isCancel(error) || error?.name === "CanceledError") throw error;
      return (
        error.response?.data || {
          code: 500,
          message: "獲取歷史在場率資料失敗",
        }
      );
    }
  },

  GetVitals: async (
    machineID,
    personnelId,
    startMs,
    endMs,
    intervalS,
    signal,
  ) => {
    try {
      const response = await axios.get(
        `${server}indoor-positioning/${machineID}/history/vitals`,
        {
          params: {
            personnel_id: personnelId,
            start: fmt(startMs),
            end: fmt(endMs),
            interval: intervalS,
          },
          signal,
        },
      );
      return response.data;
    } catch (error) {
      if (axios.isCancel(error) || error?.name === "CanceledError") throw error;
      return (
        error.response?.data || {
          code: 500,
          message: "獲取生理數據失敗",
        }
      );
    }
  },
};

export default IndoorPositioningHistory;
